$(function() {
    $(`<style>
        #tooltip {
  text-align: center;
  color: #fff;
  background: #111;
  position: absolute;
  z-index: 999;
  padding: 15px;
  border-radius: 5px;
}

#tooltip::after {  /* triangle decoration */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #111;
  content: '';
  position: absolute;
  left: 50%;
  bottom: -10px;
  margin-left: -10px;
}

#tooltip.top::after {
  border-top-color: transparent;
  border-bottom: 10px solid #111;
  top: -20px;
  bottom: auto;
}

#tooltip.left::after {
  left: 10px;
  margin: 0;
}

#tooltip.right::after {
  right: 10px;
  left: auto;
  margin: 0;
}
</style>`).appendTo('head');
    $(document).on('mouseenter focusin', '[data-toggle=tooltip]', function(e) {
        const target  = $(this);
        const tip = target.attr('title');
        if(!tip || $('#tooltip').length)
            return false;

        const tooltip = $('<div id="tooltip" role="tooltip"></div>');
        target.removeAttr('title');
        target.attr('aria-describedby', 'tooltip');
        tooltip.css('opacity', 0)
               .html(tip)
               .appendTo('body');
 
        var init_tooltip = function() {
            if($(window).width() < tooltip.outerWidth() * 1.5)
                tooltip.css('max-width', $(window).width() / 2);
            else
                tooltip.css('max-width', 340);
 
            var pos_left = target.offset().left + (target.outerWidth() / 2) - (tooltip.outerWidth() / 2),
                pos_top  = target.offset().top - tooltip.outerHeight() - 20;
 
            if(pos_left < 0) {
                pos_left = target.offset().left + target.outerWidth() / 2 - 20;
                tooltip.addClass('left');
            }
            else
                tooltip.removeClass('left');
 
            if(pos_left + tooltip.outerWidth() > $(window).width()) {
                pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
                tooltip.addClass('right');
            }
            else
                tooltip.removeClass('right');
 
            if(pos_top < 0) {
                pos_top  = target.offset().top + target.outerHeight();
                tooltip.addClass('top');
            }
            else
                tooltip.removeClass('top');
 
            tooltip.css({ left: pos_left, top: pos_top })
                   .animate({ top: '+=10', opacity: 1 }, 50);
        };
 
        init_tooltip();
        $(window).resize(init_tooltip);
 
        const remove_tooltip = () => {
            $(window).off('resize', init_tooltip);
            tooltip.animate({ top: '-=10', opacity: 0 }, 50, function() {
                $(this).remove();
            });
            target.attr('title', tip);
            target.removeAttr('aria-describedby');
            target.off('mouseleave focusout', remove_tooltip);
            $(document).off('keydown', escape_tooltip);
        };
        const escape_tooltip = (e) => {
            if (e.key === 'Escape') remove_tooltip();
        };

        target.on('mouseleave focusout', remove_tooltip);
        tooltip.bind('click', remove_tooltip);
        $(document).on('keydown', escape_tooltip);
    });
});